import { render } from "./NotFound.vue?vue&type=template&id=44b1026a&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=44b1026a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-44b1026a"

export default script